import PageWrapper from "components/ui/PageWrapper";
import BookHeader from "features/books/components/BookHeader";
import BookTabs from "features/books/components/BookTabs";

interface BookLayoutProps {
  children: React.ReactElement;
}

export default function BookLayout({
  children
}: BookLayoutProps) {

  return (
    <PageWrapper>
      <BookHeader />
      <BookTabs />
      {children}
    </PageWrapper>
  );
}
